import { TEACHER_PREFERENCE_STATUS } from '../constants/preferences';

// Type for the status enum
export type PreferenceStatus = typeof TEACHER_PREFERENCE_STATUS[keyof typeof TEACHER_PREFERENCE_STATUS];

// Type for the owner type enum
export type PreferenceOwnerType = 'teacher' | 'group';

// Type for the day enum
export type PreferenceDay = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday';

// Interface for raw preference data from API
export interface RawPreferenceData {
  id?: number;
  owner_type: PreferenceOwnerType;
  owner_id: number;
  institution_id: number;
  day: PreferenceDay;
  start_time: string; // HH:MM:SS format
  end_time: string; // HH:MM:SS format
  status: PreferenceStatus;
  createdAt?: string;
  updatedAt?: string;
}

class Preference {
  id?: number;
  ownerType: PreferenceOwnerType;
  ownerId: number;
  institutionId: number;
  day: PreferenceDay;
  startTime: string;
  endTime: string;
  status: PreferenceStatus;
  createdAt?: string;
  updatedAt?: string;

  constructor(data: RawPreferenceData) {
    this.id = data.id;
    this.ownerType = data.owner_type;
    this.ownerId = data.owner_id;
    this.institutionId = data.institution_id;
    this.day = data.day;
    this.startTime = data.start_time;
    this.endTime = data.end_time;
    this.status = data.status;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  toRawData(): RawPreferenceData {
    return {
      id: this.id,
      owner_type: this.ownerType,
      owner_id: this.ownerId,
      institution_id: this.institutionId,
      day: this.day,
      start_time: this.startTime,
      end_time: this.endTime,
      status: this.status,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }

  static fromRawDataArray(rawData: RawPreferenceData[]): Preference[] {
    return rawData.map(data => new Preference(data));
  }
}

export default Preference; 